(function () {
  'use strict';

  /* ─── Rate limiting: max 3 submissions per session ─── */
  var SUBMIT_KEY = 'aria_sub_count';
  var SUBMIT_MAX = 3;

  function getSubmitCount() {
    try { return parseInt(sessionStorage.getItem(SUBMIT_KEY) || '0', 10); } catch (e) { return 0; }
  }
  function incrementSubmitCount() {
    try { sessionStorage.setItem(SUBMIT_KEY, String(getSubmitCount() + 1)); } catch (e) {}
  }

  /* ─── Input sanitization ─── */
  function sanitize(str, maxLen) {
    if (typeof str !== 'string') return '';
    return str.trim().slice(0, maxLen || 200).replace(/[<>"'`]/g, '');
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function isValidUrl(url) {
    if (!url) return true;
    try { var u = new URL(url); return u.protocol === 'https:' || u.protocol === 'http:'; }
    catch (e) { return false; }
  }

  /* ─── Show success state ─── */
  function showSuccess(form) {
    var success = document.getElementById('aria-success');
    if (!form || !success) return;
    form.style.display = 'none';
    var label = document.querySelector('.aria-cta__form-label');
    if (label) label.style.display = 'none';
    success.style.display = 'flex';
    setTimeout(function () {
      success.classList.add('is-active');
      success.style.opacity = '1';
    }, 50);
  }

  /* ─── Attach directly to the form element — no global window assignment ─── */
  var form = document.getElementById('aria-waitlist-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    /* Honeypot check: real users leave this blank */
    var hp = document.getElementById('aria-hp');
    if (hp && hp.value !== '') return;

    /* Rate limit check */
    if (getSubmitCount() >= SUBMIT_MAX) return;

    var btn = form.querySelector('.aria-cta__btn');
    var btnSpan = btn ? btn.querySelector('span') : null;

    /* Extract + sanitize fields */
    var nameEl   = form.querySelector('[name="contact[name]"]');
    var emailEl  = form.querySelector('[name="contact[email]"]');
    var socialEl = form.querySelector('[name="contact[social]"]');

    var rawName   = sanitize(nameEl   ? nameEl.value   : '', 100);
    var rawEmail  = sanitize(emailEl  ? emailEl.value  : '', 254);
    var rawSocial = sanitize(socialEl ? socialEl.value : '', 200);

    /* Validate */
    if (!rawName || rawName.length < 2) return;
    if (!isValidEmail(rawEmail)) return;
    if (rawSocial && !isValidUrl(rawSocial)) rawSocial = '';

    /* Split name */
    var nameParts = rawName.split(' ');
    var firstName = nameParts[0] || '';
    var lastName  = nameParts.slice(1).join(' ') || '';

    var payload = {
      email:            rawEmail,
      firstName:        firstName,
      lastName:         lastName,
      socialMedia:      rawSocial,
      acceptsMarketing: true,
      tags:             rawSocial ? 'social-signup' : 'email-signup'
    };

    /* Visual feedback */
    if (btn) {
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';
    }
    if (btnSpan) btnSpan.textContent = 'Authenticating...';

    /* Submit */
    var WEBHOOK_URL = 'https://hook.eu1.make.com/6rg9ewkqlogv1ty259h1cmonvnnayxpr';

    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (response) {
      if (!response.ok) throw new Error('failed');
      incrementSubmitCount();
      showSuccess(form);
    })
    .catch(function () {
      incrementSubmitCount();
      showSuccess(form);
    });

    return false;
  });

})();
